import * as React from 'react';
import './MyNavItem.scss';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgIcon } from '@material-ui/core';
import classnames from 'classnames';

export interface MyNavItemProps {
    id?: string,
    text?: string,
    href?: string,
    icon?: React.ComponentType,
    forceWhite?: boolean,
}

const MyNavItem: React.FC<MyNavItemProps> = (props) => {
    const {
        id,
        href,
        text,
        icon,
        forceWhite,
    } = props;

    const IconComponent = icon || SvgIcon;

    return (
        <NavItem className={classnames({'item': true, 'forceWhite': forceWhite})}>
            <NavLink id={id ? `${id}-link` : undefined} tag={Link} to={href}>
                { icon && <IconComponent className="itemIcon"/> }
                { text }
            </NavLink>
        </NavItem>
    );
}

export default MyNavItem;